module.exports = __webpack_public_path__ + "static/media/EmilyWirtz_030121.77f703dd.pdf";